/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetCompositionsDetailSocialUploadsQueryResponse, GetCompositionsDetailSocialUploadsPathParams } from "../models/GetCompositionsDetailSocialUploads";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getCompositionsDetailSocialUploads } from "../axios/getCompositionsDetailSocialUploads";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getCompositionsDetailSocialUploadsQueryKey = (id: GetCompositionsDetailSocialUploadsPathParams["id"]) => ["web-app-bff-api", { url: '/compositions/:id/social-uploads', params: {id:id} }] as const

export type GetCompositionsDetailSocialUploadsQueryKey = ReturnType<typeof getCompositionsDetailSocialUploadsQueryKey>

export function getCompositionsDetailSocialUploadsQueryOptions(id: GetCompositionsDetailSocialUploadsPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getCompositionsDetailSocialUploadsQueryKey(id)
        return queryOptions<GetCompositionsDetailSocialUploadsQueryResponse, ResponseErrorConfig<Error>, GetCompositionsDetailSocialUploadsQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return getCompositionsDetailSocialUploads(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List social uploads for a composition
 * {@link /compositions/:id/social-uploads}
 */
export function useGetCompositionsDetailSocialUploads<TData = GetCompositionsDetailSocialUploadsQueryResponse, TQueryData = GetCompositionsDetailSocialUploadsQueryResponse, TQueryKey extends QueryKey = GetCompositionsDetailSocialUploadsQueryKey>(id: GetCompositionsDetailSocialUploadsPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<GetCompositionsDetailSocialUploadsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getCompositionsDetailSocialUploadsQueryKey(id)
         

         const query = useQuery({
          ...getCompositionsDetailSocialUploadsQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}